import * as React from "react";

const IconArrowTallRight: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="34" height="78" viewBox="0 0 34 78" fill="currentColor"><g fill="none" fillRule="evenodd"><rect width="34" height="78" fill="#333" opacity=".75"/><polygon fill="#FFF" fillRule="nonzero" points="24 39 10 50 10 28"/></g></svg>;
};

export default React.memo(IconArrowTallRight);
